import React from 'react';
import Button from 'components/DesignSystem/Button';
import './index.scss';

export default function DownloadButton({ onClick, disabled }: {
  onClick: () => void,
  disabled: boolean,
}) {
  return (
    <Button
      className="image-download-button"
      onClick={onClick}
      disabled={disabled}
      icon="download"
      small
    />
  );
}
